// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7964":"920981ba","8470":"7d5fdece","9310":"920981ba"}[chunkId] + ".chunk.css";
};